import React from 'react';
import ORSMActivation from './ORSMActivation';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import { Size } from '../../../../Enums/Size.enum';
import { Subscription, SubscriptionPeriod } from '../../../../graphql/graphql';

interface Props extends BaseModalProps {
	rootWorkplaceId: string;
	subscription: Subscription;
	subscriptionPeriod: SubscriptionPeriod;
}

const ORSMActivationModal: React.FC<Props> = props => {
	return (
		<BaseModal
			{...props}
			title='component.ORSMActivation.modalTitle'
			size={Size.LG}>
			<ORSMActivation
				rootWorkplaceId={props.rootWorkplaceId}
				subscription={props.subscription}
				subscriptionPeriod={props.subscriptionPeriod}
			/>
		</BaseModal>
	);
};

export default ORSMActivationModal;
